export default __webpack_public_path__ + "static/media/User3.102a70cd.png";